import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './BudgetTable.html?raw';
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import SpreadsheetTable from '../../moreCore/UI/Spreadsheet/SpreadsheetTable';
import lang from 'dojo/_base/lang';
import { uiFrameTypes } from "../../moreCore/UI/Container/uiFrameTypes";
import NumberInput from '../../moreCore/UI/NumberInput/NumberInput';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import Button from '../../moreCore/UI/Button/Button';
import "../../moreCore/UI/Button/Button";
import SelectBox from '../../moreCore/UI/SelectBox/SelectBox';
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import { StringHelpers, TranslationHelpers } from "../../more/Helpers";
import { ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import FloatingContainer from '../../moreCore/UI/Floating/FloatingContainer';
import Edit from '../../moreCore/UI/Edit/Edit';
import { GenericDialogTypes } from "../../moreCore/UI/GenericDialog/GenericDialogTypes";

class BudgetTable extends compose(_uiFrameMixin) {
    templateString: any = template;

    private configurationData: BudgetTypes.BudgetTableConfiguration;

    private costCalculationTable: MdsLax<InstanceType<typeof SpreadsheetTable<BudgetTypes.EvCost>>>;
    private priceScaleTable: MdsLax<InstanceType<typeof SpreadsheetTable<BudgetTypes.PriceScaleCalculation>>>;
    private pricesTable: MdsLax<InstanceType<typeof SpreadsheetTable<BudgetTypes.PriceScaleCalculation>>>;

    private sectionCostCalculation: HTMLElement;
    private costCalculationContainer: HTMLElement;
    private sectionPriceScale: HTMLElement;
    private priceScaleContainer: HTMLElement;
    //private buttonsContainerTopLeft: HTMLElement;
    //private buttonsContainerTopRight: HTMLElement;
    //private buttonsContainerTopCenter: HTMLElement;
    private buttonsContainerPriceScale: HTMLElement;
    private buttonsContainerPriceScaleRight: HTMLElement;
    private buttonsContainerCostCalculation: HTMLElement;
    private buttonsContainerCostCalculationRight: HTMLElement;
    private selectTemplateContainer: HTMLElement;

    private sectionFinanceInfoPlanning: HTMLElement;
    private txtFinanceInfoPlanning: HTMLElement;

    private btnCommitCostCalculationChanges: MdsLax<InstanceType<typeof Button>>;
    private btnUndoCostCalculationChanges: MdsLax<InstanceType<typeof Button>>;
    private btnAddCostRow: MdsLax<InstanceType<typeof Button>>;
    private btnAddPctColumn: MdsLax<InstanceType<typeof Button>>;

    //private availableCosttypes: Array<BudgetTypes.EvCostRevenueType>;

    private _evProjectId: string;

    setup(configuration: BudgetTypes.BudgetTableConfiguration, openAs?: uiFrameTypes.DisplayMode, title?: string, showAtNode?: HTMLElement)
    setup(projectID: string, openAs?: uiFrameTypes.DisplayMode, title?: string, showAtNode?: HTMLElement)
    setup(unknown: any, openAs ?: uiFrameTypes.DisplayMode, title ?: string, showAtNode?: HTMLElement) {

            if (!unknown) {

            }
            else if (typeof unknown == "string") {
                this._evProjectId = unknown;
            } else if (typeof unknown == "object") {
                this._setConfigurationData(unknown);
            }


        if (openAs) this.show(openAs, title, showAtNode);

        else if (this.isActive && !this.configurationData && this._evProjectId) {
            this._loadConfigurationData();
        }
    }

    protected onShow() {
        if (this._evProjectId && !this.configurationData) {
            this._loadConfigurationData();
        }
    }

    protected onExpand(state: boolean) {

    }

    private _loadConfigurationHandle;
    private _loadConfigurationData() {
        //console.trace(this.id + " _loadConfigurationData");
        if (this._loadConfigurationHandle) {
            
            return;
        }

        this.StandbyStart();

        let data = {
            "projectID": this._evProjectId
        };

        this._loadConfigurationHandle = this.RequestManager.callfunction("Webtool_API_BudgetCalculation__GetMainConfig",
            data,
            lang.hitch(this, this._onLoadConfigurationResponse, true),
            lang.hitch(this, this._onLoadConfigurationResponse, false),
        );
    }

    private _onLoadConfigurationResponse(success: boolean, response) {
        this._loadConfigurationHandle = null;

        this.disableNode(this.sectionCostCalculation, !success);
        this.disableNode(this.sectionPriceScale, !success);

        this.StandbyStop();


        if (success === true) {
            this._setConfigurationData(response);
        } else {
            let error = response as more.requestErrorMessage;
            this.showToast({
                title: "error loading configuration",
                message: error.Message,
                iconClass: toasterIcons.error
            });
        }
    }

    private _emptyCalculation() {
        if (this.configurationData?.privileges?.editCostCalculation) {
            let dlg = new GenericDialog();
            dlg.setup("confirmDelete", lang.hitch(this, this._onConfirmDeleteCalculation), "BudgetCalculation_Message__ConfirmDeleteCalculation", "BudgetCalculation_Label__DeleteCalculation");
        }
    }

    private _onConfirmDeleteCalculation(result: GenericDialogTypes.GenericDialogResult) {
        if (result == GenericDialogTypes.GenericDialogResult.ok) {
            let data = {
                "projectID": this._evProjectId
            };

            this.StandbyStart()

            this.RequestManager.callfunction("Webtool_API_BudgetCalculation__DeleteCalculation",
                data,
                lang.hitch(this, this._onDeleteCalculationResponse, true),
                lang.hitch(this, this._onDeleteCalculationResponse, false),
            );
        }

        
    }

    private _onDeleteCalculationResponse(success: boolean, response) {

        if (success === true) {
            if (this._btnDeleteCalc) {
                this._btnDeleteCalc.destroy();
                this._btnDeleteCalc = null;
            }

            this.configurationData = null;
            this._loadConfigurationData();

            this.showToast("General_Delete_Success");

        } else {
            let error = response as more.requestErrorMessage;
            this.showToast({
                title: "error deleting configuration",
                message: error.Message,
                iconClass: toasterIcons.error
            });
        }

        this.StandbyStop();
    }

    private _inputTemplate: MdsLax<InstanceType<typeof SelectBox>>;
    private _btnDeleteCalc: MdsLax<InstanceType<typeof Button>>;

    private _setConfigurationData(data: Partial<BudgetTypes.BudgetTableConfiguration>) {

        if (typeof data != "object" || !data) return;
        //this.costCalculationTable = null;
        //this.priceScaleTable = null;
        this.disableNode(this.sectionCostCalculation, false);

        if (data?.projectID) this._evProjectId = data.projectID;
        
        
        if (!this.configurationData) this.configurationData = {} as any; // Stumpf anlegen, falls noch nicht alles in der Response daherkommt

        // Achtung, die daten können auch unvollständig sein, weil zb nur die eine oder andere Tabelle nachgeladen worden ist.
        // Übertragen was da ist, aber die bestehenden Daten dalassen!
        for (let key in data) {
            this.configurationData[key] = data[key];
        }
        //if (data.availableCosttypes) {
        //    this.availableCosttypes = data.availableCosttypes;
        //}

        if (data.privileges) this.configurationData.privileges = data.privileges;

        this.txtFinanceInfoPlanning.innerHTML = data.finance_info_planning ? data.finance_info_planning : TranslationHelpers.translate("BudgetCalculation_Message__EmptyFinanceInfoPlanning");
        this.disableNode(this.txtFinanceInfoPlanning, !data.finance_info_planning);
        //this.hideNode(this.sectionFinanceInfoPlanning, !data.finance_info_planning);

        //if (data.title) this.setTitles(data.title);

        if (data.costTableConfig) {
            this.UiModder.domConstruct.empty(this.costCalculationContainer);

            this.configurationData.costTableConfig = data.costTableConfig;

            if (data.costEntities.length == 0) {

                let infoP = this.UiModder.domConstruct.create("p", {
                    className: "infoBG",
                    innerHTML: TranslationHelpers.translate("BudgetCalculation_Message__NoCostEntitiesInProject")
                }, this.costCalculationContainer);

                if (data.budgetTemplates?.length) {
                    let templateSelect = new SelectBox();
                    templateSelect.setBlankOption(null, "BudgetCalculation_Label__SelectBudgetTemplate");
                    templateSelect.setData(null, data.budgetTemplates, "ID", "description");
                    templateSelect.setLabel("BudgetCalculation_Label__CreateBudgetFromTemplate");
                    templateSelect.setLabelPosition("front");
                    templateSelect.placeAt(this.selectTemplateContainer, "only");

                    templateSelect.on("change", lang.hitch(this, this._onSelect_BudgetTemplate, templateSelect));

                    this._inputTemplate = templateSelect;
                }

            } else {

                if (this._inputTemplate) {
                    this._inputTemplate.destroy();
                    this._inputTemplate = null;
                }

                this.costCalculationTable = new SpreadsheetTable();
                //this.costCalculationTable.placeAt(this.costCalculationContainer, "only");
                this.costCalculationTable.show("node", this.costCalculationContainer);

                data.costTableConfig.permanentEditingMode = true;
                data.costTableConfig.columnActions = {
                    "fixCM": {
                        callback: lang.hitch(this, this._onClick_FixUtilizationLevelColumn),
                        iconClass: "fas fa-thumbtack",
                        //label: "BudgetCalculation_Label__FixUtilizationLevelColumn",
                        priorityType: "primary",
                        enableCallback: lang.hitch(this, this._onCheck_FixUtilizationLevelColumn),
                        visibleCallback: lang.hitch(this, this._onCheck_FixUtilizationLevelColumn)
                    },
                    "unfixCM": {
                        callback: lang.hitch(this, this._onClick_FixUtilizationLevelColumn),
                        iconClass: "fas fa-unlock",
                        //label: "BudgetCalculation_Label__FixUtilizationLevelColumn",
                        priorityType: "primary",
                        enableCallback: lang.hitch(this, this._onCheck_UnfixUtilizationLevelColumn),
                        visibleCallback: lang.hitch(this, this._onCheck_UnfixUtilizationLevelColumn),
                    },
                    "modifyPct": {
                        callback: lang.hitch(this, this._onClick_ModifyPctColumn),
                        enableCallback: lang.hitch(this, this._onCheck_RemovePctCol),
                        visibleCallback: lang.hitch(this, this._onCheck_RemovePctCol),
                        iconClass: "fas fa-percent",
                        priorityType: "secondary",
                        //style: "secondary"
                        //label: "remove"
                    },
                    "removePct": {
                        callback: lang.hitch(this, this._onRemovePctCol),
                        enableCallback: lang.hitch(this, this._onCheck_RemovePctCol),
                        visibleCallback: lang.hitch(this, this._onCheck_RemovePctCol),
                        iconClass: "fas fa-trash",
                        priorityType: "default",
                        styleClass: "deleteBtn"
                        //label: "remove"
                    }
                };
                data.costTableConfig.rowStyleFormatter = lang.hitch(this, this._onFormat_CalcTableRow);
                data.costTableConfig.headerStyleFormatter = lang.hitch(this, this._onFormat_CalcTableHead);
                data.costTableConfig.cellStyeFormatter = lang.hitch(this, this._onFormat_CalcTableCell);
                data.costTableConfig.summaryCellsFormatter = lang.hitch(this, this._onFormat_CalcTableSummary);
                data.costTableConfig.cellEditableCheck = lang.hitch(this, this._onCheck_EditCostRowValue);
                
                data.costTableConfig.rowActions = {
                    "removeRow": {
                        callback: lang.hitch(this, this._onRemoveCostRow),
                        visibleCallback: lang.hitch(this, this._onCheck_RemoveCostRow),
                        iconClass: "fas fa-trash",
                        styleClass: "deleteBtn"
                        //label: "BudgetCalculation_Label__RemoveCostType",
                    },
                    "notepopup": {
                        callback: lang.hitch(this, this._onPopupNote),
                        
                        iconClass: "fas fa-edit",
                        priorityType: "secondary"
                    },
                    "infoPopup": {
                        callback: lang.hitch(this, this._onPopupInfo),
                        visibleCallback: lang.hitch(this, this._onCheck_PopupInfo),
                        iconClass: "fas fa-info",
                        styleClass: "infoBtn",
                        enableIfReadonly: true
                    }
                }

                data.costTableConfig.title = null; // Überschrift können wir im Layout nicht brauchen

                if (!this.configurationData.privileges.editCostCalculation) {
                    this.costCalculationTable.setReadonly(true);
                } else {
                    // wir statten alle Spalten, außer die 100er, mit einer eigenen Kalkulation aus
                    for (let col of this.configurationData.costTableConfig.columns) {
                        if (col.columnID != "100") {
                            let pctVal = parseFloat(col.columnID);
                            if (!isNaN(pctVal)) {
                                col.formula = {
                                    triggeringColumns: [{ columnID: "100" }],
                                    //calcFunction: "invalidate"//lang.hitch(this, this._calcPctValue)
                                    calcFunction: lang.hitch(this, this._onCalcCell)
                                }
                            }
                        }
                    }

                    //this.costCalculationTable.on("change", lang.hitch(this, this._onChangeCostCalculationTable));
                    this.costCalculationTable.on("dirty", lang.hitch(this, this._onDirtyCostCalculationTable));
                }

                this.costCalculationTable.setup(data.costTableConfig, data.costEntities);
            }
        }

        if (data.priceScaleData) {

            this.configurationData.priceScaleData = data.priceScaleData;

            this.UiModder.domConstruct.empty(this.priceScaleContainer);
            this.priceScaleTable = new SpreadsheetTable();
            //this.priceScaleTable.placeAt(this.priceScaleContainer, "only");
            this.priceScaleTable.show("node", this.priceScaleContainer);

            this.priceScaleTable.setup({
                permanentEditingMode: true,
                rowIdAttribute: "_lvlNo",
                rowLabelAttribute: "_lvlLabel",
                columns: [{
                    columnID: "price",
                    valueAttribute: "price",
                    valueType: "currency",
                    editable: false,
                    heading: "BudgetCalculation_Label__PriceScaleCategory"
                }, {
                    columnID: "capacity",
                    valueAttribute: "capacity",
                    valueType: "int",
                    editable: false,
                    heading: "BudgetCalculation_Label__Capacity",
                    summaryDescriptors: [{
                        //heading: "total",
                        mode: "sum"
                    }]
                }, {
                    columnID: "subscribers",
                    valueAttribute: "subscribers",
                    valueType: "int",
                    editable: false,
                    unitLabel: "Per",
                    heading: "BudgetCalculation_Label__Subscribers",
                    summaryDescriptors: [{
                        //heading: "Summe",
                        mode: "sum"
                    }]
                }, {
                    columnID: "baseSum",
                    valueAttribute: "sumRevenue",
                    valueType: "currency",
                    editable: false,
                    heading: "BudgetCalculation_Label__BaseSumRevenue",
                    summaryDescriptors: [{
                        //heading: "total",
                        mode: "sum"
                    }]
                }, {
                    columnID: "discount",
                    valueAttribute: "sumDiscount",
                    valueType: "currency",
                    editable: false,
                    heading: "BudgetCalculation_Label__Discount"
                }, {
                    columnID: "sumDiscount",
                    valueAttribute: "sumDiscount",
                    valueType: "currency",
                    editable: false,
                    heading: "BudgetCalculation_Label__SumDiscount",
                    summaryDescriptors: [{
                        //heading: "total",
                        mode: "sum"
                    }]
                }, {
                    columnID: "sumTotal",
                    valueAttribute: "sumTotal",
                    valueType: "currency",
                    editable: false,
                    heading: "BudgetCalculation_Label__TotalSumRevenue",
                    summaryDescriptors: [{
                        //heading: "total",
                        mode: "sum"
                    }]
                }, {
                    columnID: "priceSingle",
                    valueAttribute: "priceSingle",
                    valueType: "currency",
                    editable: false,
                    heading: "BudgetCalculation_Label__PriceSingle"
                }, {
                    columnID: "priceLevel",
                    valueAttribute: "priceLevelPct",
                    valueType: "int",
                    unitLabel: "%",
                    editable: false,
                    heading: "BudgetCalculation_Label__PriceLevelPct"
                }]
            }, data.priceScaleData.calculationLines);
            //this.priceScaleTable.on("change", lang.hitch(this, this._onChangeCostCalculationTable));

        }

        if (!this.priceScaleTable) {
            this.UiModder.domConstruct.create("p", {
                className: "infoBG",
                innerHTML: TranslationHelpers.translate("BudgetCalculation_Message__NoPriceScaleInProject")
            }, this.priceScaleContainer, "only");
        }


        if (this._evProjectId) {
            this.addButtonEx({
                internalName: "reload",
                callback: lang.hitch(this, this._loadConfigurationData),
                label: "General_Reload",
                iconClass: "fas fa-sync"
            });

            // 
            if (this.configurationData.privileges?.editCostCalculation && (this.configurationData.costEntities?.length > 0)) {
                //this.addButtonEx({
                //    internalName: "delete",
                //    callback: lang.hitch(this, this._emptyCalculation),
                //    label: "", // "BudgetCalculation_Label__DeleteCalculation",
                //    iconClass: "fas fa-trash",
                //    position: "secondary"
                //});
                if (!this._btnDeleteCalc) {
                    let btn = new Button();
                    btn.setup({
                        callback: lang.hitch(this, this._emptyCalculation),
                        iconClass: "fas fa-trash",
                        parentNode: this.buttonsContainerCostCalculation,
                        styleClass: "warning"
                    });

                    this._btnDeleteCalc = btn;
                }
            }
        }


        this.emitStatus();

        this._handleButtons();
    }

    private _onCalcCell(value, sourceCell: SpreadsheetTableTypes.DataCell<BudgetTypes.EvCost>, targetCell: SpreadsheetTableTypes.DataCell<BudgetTypes.EvCost>): SpreadsheetTableTypes.cellValueCalcResult {

        // retour: € runtergerechnet von 100 auf die aktuelle %-Spalte
        let colPctValue = parseFloat(targetCell.column.columnID);
        let costEntity = targetCell.row.data;

        
        if (!isNaN(colPctValue) && !!sourceCell) {

            let result = value;

            
            let response: SpreadsheetTableTypes.cellValueCalcResult = {
                value: targetCell.value,
                invalidateCell: false
            };

            if (colPctValue == 100) {

            } else {
                // alles außer der 100er-Spalte wird invalidiert, wenn es der Datensatz manuelle Bearbeitung nicht zulässt
                if (costEntity.is_manually_editable_values != true) {
                    response.invalidateCell = true;
                }
            }


            return response;
        }
    }
    //private _onCalcCell(value, sourceCell: SpreadsheetTableTypes.DataCell<BudgetTypes.EvCost>, targetCell: SpreadsheetTableTypes.DataCell<BudgetTypes.EvCost>): SpreadsheetTableTypes.cellValueCalcResult {

    //    // retour: € runtergerechnet von 100 auf die aktuelle %-Spalte
    //    let colPctValue = parseFloat(targetCell.column.columnID);
    //    let costEntity = targetCell.row.data;

        
    //    if (!isNaN(colPctValue) && !!sourceCell) {

    //        if (costEntity.is_calculate_utilization_level_ev_finance != true) return {
    //            value: sourceCell.value,
    //            invalidateCell: false
    //        };

    //        let sourceValue = sourceCell.value as number;
    //        let result = sourceValue * colPctValue / 100;

    //        let response: SpreadsheetTableTypes.cellValueCalcResult = {
    //            value: result,
    //            invalidateCell: false
    //        };

    //        return response;
    //    }
    //}

    private _handleButtons() {
        //this.addButtonEx({
        //    internalName: "addPctCol",
        //    callback: lang.hitch(this, this._onClick_AddPctColumn),
        //    label: "Pzt",
        //    iconClass: "fas fa-add"
        //});

        //this.UiModder.domConstruct.empty(this.buttonsContainerTopLeft);
        //this.UiModder.domConstruct.empty(this.buttonsContainerTopCenter);
        //this.UiModder.domConstruct.empty(this.buttonsContainerTopRight);
        //this.UiModder.domConstruct.empty(this.buttonsContainerCostCalculation);
        this.UiModder.domConstruct.empty(this.buttonsContainerPriceScale);
        this.UiModder.domConstruct.empty(this.buttonsContainerPriceScaleRight);


        let btn: MdsLax<InstanceType<typeof Button>>;
        if (!this.configurationData) return;

        if (!this.configurationData.privileges.editCostCalculation) {
            this.hideNode(this.buttonsContainerCostCalculation, true);
        }
        else/* if (true)*/ {
            this.hideNode(this.buttonsContainerCostCalculation, false);

            btn = this.btnAddCostRow;
            btn.setReadonly(!this.configurationData.availableCosttypes?.length);

            
            btn = this.btnAddPctColumn;
            btn.setReadonly(!this.costCalculationTable || this.costCalculationTable.getColumns().length >= 8 || this.costCalculationTable.getRows().length == 0);

            this.hideNode(this.btnCommitCostCalculationChanges, !this.costCalculationTable);
            this.hideNode(this.btnUndoCostCalculationChanges, !this.costCalculationTable);
        }
        if (!this.configurationData.privileges.editPriceScale) {
            this.hideNode(this.buttonsContainerPriceScale);
        }
        else if (this.priceScaleTable) {
            this.hideNode(this.buttonsContainerPriceScale, false);

            //is_fix_price_scale
            btn = new Button();
            btn.setup({
                callback: lang.hitch(this, this._onClick_FixPriceScale, true),
                label: "BudgetCalculation_Label__FixPriceScale",
                iconClass: "fas fa-check-square",
                styleClass: "smallBtn secondaryBtn",
                parentNode: this.buttonsContainerPriceScale
            });
            btn.setReadonly(this.configurationData.priceScaleData.is_fix_price_scale == true);

            btn = new Button();
            btn.setup({
                callback: lang.hitch(this, this._onClick_FixPriceScale, false),
                label: "BudgetCalculation_Label__UnfixPriceScale",
                iconClass: "fas fa-lock-open",
                styleClass: "smallBtn secondaryBtn",
                parentNode: this.buttonsContainerPriceScale
            });
            btn.setReadonly(this.configurationData.priceScaleData.is_fix_price_scale != true);

            if (this.configurationData.priceScaleData.is_fix_price_scale == true) {
                this.disableNode(this.buttonsContainerPriceScaleRight);
            } else {
                this.disableNode(this.buttonsContainerPriceScaleRight, false);
            }
        }

        if (this.configurationData.priceScaleTemplates?.length) {

            let select = new SearchSelect();
            select.setCyName("BudgetCalculation_Label_SelectedPriceScaleTemplate");
            select.setLabel("BudgetCalculation_Label__SelectedPriceScaleTemplate");
            select.setLabelPosition("front");
            select.setData(this.configurationData.selectedPriceScaleID,
                this.configurationData.priceScaleTemplates,
                true,
                "description",
                "ID");

            select.placeAt(this.buttonsContainerPriceScaleRight);
            select.on("change", lang.hitch(this, this._onSelectPriceScaleTemplate));
            
        }
    }

   

    private _onDirtyCostCalculationTable(data) {
        let isDirty = this.costCalculationTable.isDirty();
        if (isDirty) {
            // alles invalidieren, was nicht in Spalte 100 steht und alles was sich durch eine Funktion berechnet. potenziell ist sowieso alles betroffen und voneinander abhängig.
            let cells = this.costCalculationTable.getCells();
            let table = this.costCalculationTable;
            let invalidCells = cells.filter(function (cell) {
                let data = table.getRowDataEntity(cell);

                if (data.is_manually_editable_values == true) return false;

                return cell.column.columnID != "100" || cell.row.data.ref_source_budget_template_position?.ref_ev_finance_calc_callfunction != null;
            });

            this.costCalculationTable.invalidateCell(invalidCells);
        } 
        this.btnCommitCostCalculationChanges.setReadonly(!isDirty);
        this.btnUndoCostCalculationChanges.setReadonly(!isDirty);
        this.disableNode(this.buttonsContainerCostCalculation, isDirty);
        this.disableNode(this.sectionPriceScale, isDirty);

        this.emitStatus();
    }

    isDirty(): boolean {
        if (this.costCalculationTable) {
            return this.costCalculationTable.isDirty();
        }
        return false;
    }

    private _onClick_CommitCostCalculationChanges(evt: MouseEvent) {
        
        this.disableNode(this.sectionCostCalculation);
        setTimeout(lang.hitch(this, this._saveCostCalculationChanges), 500);
    }

    private _onClick_UndoCostCalculationChanges(evt: MouseEvent) {
        this.btnCommitCostCalculationChanges.setReadonly(true);
        this.btnUndoCostCalculationChanges.setReadonly(true);
        
        this._setConfigurationData(this.configurationData as any);
    }

    private _saveCostCalculationChanges() {
        let diffData = this.costCalculationTable.getChangedData();

        let data: any =
        {
            diffData: diffData,
            projectID: this._evProjectId
        };

        this.StandbyStart(this.costCalculationContainer);

        console.log("Webtool_API_BudgetCalculation__SaveCostTableData", data);
        //return;

        this.RequestManager.callfunction("Webtool_API_BudgetCalculation__SaveCostTableData",
            data,
            lang.hitch(this, this._onSaveCostTableResult, true),
            lang.hitch(this, this._onSaveCostTableResult, false)
        );
    }

    private _onSaveCostTableResult(success: boolean, response) {
        this.StandbyStop();
        if (success) {
            if (typeof (response) == "object") {
                this._setConfigurationData(response);
            }
            //console.log(this.id + " _onSaveCostTableResult", response);
        } else {
            let error = response as more.requestErrorMessage;
            ///console.error(this.id + " _onSaveCostTableResult");
            this.showToast({
                title: "error saving costs table data",
                message: error.Message,
                iconClass: toasterIcons.error
            });
        }
    }

    private _onSelectPriceScaleTemplate(newID: string) {
        if (this.configurationData.priceScaleData && this.configurationData.priceScaleData.is_fix_price_scale == true) return;

        this._changePriceScale({ templateID: newID });
    }


    private _onCheck_PopupInfo(row: SpreadsheetTableTypes.DataRow<BudgetTypes.EvCost>): boolean {
        let description = row.data.ref_source_budget_template_position?.ref_ev_finance_calc_callfunction?.description;
        let descriptonLong = row.data.ref_source_budget_template_position?.ref_ev_finance_calc_callfunction?.description_long;
        if (!descriptonLong && !description) {
            return false;
        }

        return true;
    }
    private _onPopupInfo(row: SpreadsheetTableTypes.DataRow<BudgetTypes.EvCost>, evt) {
        //if (row.data.note)

        //let dlg = new GenericDialog();
        //dlg.setup({
        //    size: "smaller",
        //    content: row.data.note,
        //    buttonPreset: "close",
        //    header: row.label
        //});
        
        let description = row.data.ref_source_budget_template_position?.ref_ev_finance_calc_callfunction?.description;
        let descriptonLong = row.data.ref_source_budget_template_position?.ref_ev_finance_calc_callfunction?.description_long;

        if (!descriptonLong && !description) {
            return false;
        }
        
        let popup = new FloatingContainer();


        let container = this.UiModder.domConstruct.create("div", {
            className: "infoBG",
            style: {
                "maxWidth": "50ch",
                "textAlign": "initial"
            }
        });

        if (description) {
            let desc = this.UiModder.domConstruct.create("h6", {
                className: "transparent noMargin",
                innerHTML: description
            }, container);
        }

        if (descriptonLong) {
            let content = this.UiModder.domConstruct.create("pre", {
                className: "transparent",
                innerHTML: descriptonLong
            }, container);
        }


        popup.open(evt, container, false, true);
    }

    private _onPopupNote(row: SpreadsheetTableTypes.DataRow<BudgetTypes.EvCost>, evt) {
        //if (row.data.note)

        //let dlg = new GenericDialog();
        //dlg.setup({
        //    size: "smaller",
        //    content: row.data.note,
        //    buttonPreset: "close",
        //    header: row.label
        //});

        if (!row.data.note || row.data.note == "") {
            this._onClick_EditNote(row, evt);
            return;
        }
        
        let popup = new FloatingContainer();




        let container = this.UiModder.domConstruct.create("p", {
            className: "infoBG noIcon alignTop",
            style: {
                "maxWidth": "50ch"
            }
        });


        let content = this.UiModder.domConstruct.create("pre", {
            className: "transparent",
            innerHTML: row.data.note ? row.data.note : ""
        }, container);

        let editBtn = new Button();
        editBtn.setup({
            iconClass: "fas fa-edit",
            styleClass:"smallBtn",
            callback: lang.hitch(this, this._onClick_EditNote, row),
            parentNode: container
        });

        popup.open(evt, container, false, true);
    }

    private _onClick_EditNote(row: SpreadsheetTableTypes.DataRow<BudgetTypes.EvCost>, evt: PointerEvent) {
        evt.preventDefault();
        evt.stopPropagation();


        let container = this.UiModder.domConstruct.create("div");


        let editDescription = new Edit();
        editDescription.setLabel("General_Description");
        editDescription.setValue(row.data.description);
        editDescription.placeAt(container);

        let edit = new Edit();
        edit.setLabel("General_Label_Note");
        edit.setIsMultiline(true);
        edit.setValue(row.data.note);
        edit.placeAt(container);


        let dlg = new GenericDialog();
        dlg.setup({
            header: TranslationHelpers.translate("General_Label_Edit") + (row.label ? " - " +  row.label : "") ,
            buttonPreset: "okcancel",
            distinctiveNoCallback: "silentclose",
            callback: lang.hitch(this, this._onEditNote, row, edit, editDescription),
            content: container
        });

        edit.focus();

    }
    private _onEditNote(row: SpreadsheetTableTypes.DataRow<BudgetTypes.EvCost>, edit: MdsLax<InstanceType<typeof Edit>>, editDescription: MdsLax<InstanceType<typeof Edit>>) {
        let newValue = edit.getValue();
        let newDescription = editDescription.getValue();

        this.RequestManager.callfunction("Webtool_API_BudgetCalculation__ChangeCostEntityNote", {
            "costEntityID": row.rowID,
            "note": newValue,
            "description": newDescription
        },
            lang.hitch(this, this._onNoteChangedResponse, true, newValue, newDescription, row),
            lang.hitch(this, this._onNoteChangedResponse, false, null, null, row),
        true);
    }


    private _onNoteChangedResponse(success: boolean, newValue, newDescription, row: SpreadsheetTableTypes.DataRow<BudgetTypes.EvCost>, response) {
        if (success === true) {
            row.data.note = newValue;
            row.data.description = newDescription;
            this.costCalculationTable.sendUIsignal(row);
        } else {
            let error = response as more.requestErrorMessage;
            ///console.error(this.id + " _onFixPriceScaleResult");
            this.showToast({
                title: "error saving note",
                message: error.Message,
                iconClass: toasterIcons.error
            });
        }
    }

    private _onRemoveCostRow(row: SpreadsheetTableTypes.DataRow) {
        if (this.costCalculationTable.isDirty()) {
            this.showToast("BudgetCalculation_Message__SavePendingChangesFirst", toasterIcons.info);
            return;
        }
        this._modifyCostRow(row.rowID, null, "remove");
    }

    private _onCheck_EditCostRowValue(cell: SpreadsheetTableTypes.DataCell<BudgetTypes.EvCost>): boolean {
        let row = this.costCalculationTable.getRow(cell);
        let costEntity = this.costCalculationTable.getRowDataEntity(cell);
        let col = this.costCalculationTable.getColumn(cell);
        // außer in der 100er-Spalte darf grundsätzlich mal nix geändert werden
        if (col.columnID != "100") {
            // abseits der 100er-Spalte zulassen, falls der Kosteneintrag es zulässt
            if (costEntity?.is_manually_editable_values === true) return true;
            return false;
        }
        if (costEntity?.ref_source_budget_template_position?.is_lock_edit_value === true) return false;
        if (costEntity?.is_manually_editable_values === true) return true;
        if (costEntity?.revenue_expense_type == "E") return false;
        else if (!costEntity) return false;
        return true;
    }
    private _onCheck_RemoveCostRow(row: SpreadsheetTableTypes.DataRow<BudgetTypes.EvCost>): boolean {
        if (row.data.ref_source_budget_template_position?.is_lock_deleting === true) return false;
        return true;
    }

    private _onCheck_RemovePctCol(col: SpreadsheetTableTypes.Column): boolean {
        if (this.isUtilizationFixed(col) == true) return false;
        if (col.columnID != "100") return true;
        return false;
    }
    private _onRemovePctCol(col: SpreadsheetTableTypes.Column) {
        if (this.costCalculationTable.isDirty()) {
            this.showToast("BudgetCalculation_Message__SavePendingChangesFirst", toasterIcons.info);
            return;
        }
        let value = parseInt(col.columnID);
        this._changeUtilizationLevel(value, "remove");

        this.disableNode(col.headerCellNode);
        let cellNodes = this.costCalculationTable.getCells(col).map(entry => entry.node);
        this.disableNode(cellNodes);
    }

    private _onClick_FixPriceScale(fixTarget: boolean, evt: PointerEvent) {
        this._changePriceScale({ fixScale: fixTarget });
    }
    private _changePriceScale(params: { fixScale?: boolean, templateID?: string }) {
        let data: any =
        {
            ...params,
            pricescaleID: this.configurationData.priceScaleData?.ID,
            projectID: this._evProjectId
        };

        this.StandbyStart(this.priceScaleContainer);

        this.disableNode(this.sectionCostCalculation);

        console.log("Webtool_API_BudgetCalculation__ChangePriceScale", data);
        //return;

        this.RequestManager.callfunction("Webtool_API_BudgetCalculation__ChangePriceScale",
            data,
            lang.hitch(this, this._onChangePriceScaleResult, true),
            lang.hitch(this, this._onChangePriceScaleResult, false)
        );
    }

    private _onChangePriceScaleResult(success: boolean, response) {
        this.StandbyStop();
        this.disableNode(this.sectionCostCalculation, false);
        if (success) {
            //console.log(this.id + " _onFixPriceScaleResult", response);
            if (typeof response == "object") {
                this._setConfigurationData(response);
            }
        } else {
            let error = response as more.requestErrorMessage;
            ///console.error(this.id + " _onFixPriceScaleResult");
            this.showToast({
                title: "error saving price scale",
                message: error.Message,
                iconClass: toasterIcons.error
            });
        }
    }

    private _onFormat_CalcTableRow(row: SpreadsheetTableTypes.DataRow<BudgetTypes.EvCost>): SpreadsheetTableTypes.rowFormatterResult {
        
        let result: SpreadsheetTableTypes.rowFormatterResult = {
            
        };

        if (row.data.description != row.data.ref_vt_cost_revenue_type.description) {
            result.overrideInfotext = row.data.description
        }

        return result;
        
    }
    private _onFormat_CalcTableHead(col: SpreadsheetTableTypes.Column<BudgetTypes.EvCost>): SpreadsheetTableTypes.columnFormatterResult {
        
        if (this._onCheck_UnfixUtilizationLevelColumn(col) == true) // ist schon fixiert
        {
            let result: SpreadsheetTableTypes.columnFormatterResult = {
                styleTemplate: "highlight1"
            };
            //result.borderColor = "var(--primary)";
            //result.mainBackgroundColor = "var(--accentThemeTransparent)";
            //result.overrideInfotext = col.infoText + " FIXIERT";
            //result.overrideLabel = col.heading + " FIX";
            

            return result;
        }

        return false;
    }

    private _onFormat_CalcTableCell(cell: SpreadsheetTableTypes.DataCell<BudgetTypes.EvCost>): SpreadsheetTableTypes.cellFormatterResult {
        if (this.isUtilizationFixed(cell.column)) return { styleTemplate: "highlight1" };
        return false;
    }

    private _onFormat_CalcTableSummary(cell: SpreadsheetTableTypes.SummaryCell<BudgetTypes.EvCost>): SpreadsheetTableTypes.cellFormatterResult {

        let result: SpreadsheetTableTypes.cellFormatterResult = {
            styleTemplate: "default"
        };

        if (cell.value < 0) result.styleTemplate = "negative";
        else if (this.isUtilizationFixed(cell.column)) result.styleTemplate = "highlight1";
        else result = false;

        this.emitStatus();

        return result;
    }

    private _onClick_AddCostRow() {

        let container = this.UiModder.domConstruct.create("div");

        let select = new SelectBox();
        select.setBlankOption(null, "BudgetCalculation_Label__SelectCostType");
        select.setLabel("BudgetCalculation_Label__CostType");
        select.setData(null,
            this.configurationData.availableCosttypes,
            "ID",
            "description",
            false,
            "coloration",
            "coloration");

        select.placeAt(container);

        let editDescription = new Edit();
        editDescription.setLabel("General_Description");
        editDescription.placeAt(container);
        

        let numberInput = new NumberInput();
        numberInput.setLabel("BudgetCalculation_Label__CostValue");
        numberInput.setValue(0);
        numberInput.setPlaces(2);
        numberInput.setNumberType("currency");

        numberInput.placeAt(container);

        let dlg = new GenericDialog();
        dlg.setup({
            content: container,
            header: "BudgetCalculation_Label__AddCostType",
            callback: lang.hitch(this, this._onAddCostRowDlg, select, numberInput, editDescription),
            buttonPreset: "okcancel",
            distinctiveNoCallback: "silentclose",
            size: "smaller"
        });

        //dlg.addWidgetToContent(numberInput, "last");
        
        dlg.disableButton("ok");

        numberInput.on("change", lang.hitch(dlg, "enableButton", "ok"));
        select.on("change", lang.hitch(dlg, "enableButton", "ok"));
        select.on("change", lang.partial(function (costtypes: BudgetTypes.EvCostRevenueType[]) {
            let id = select.getValue();
            if (id) {
                let filterresult = costtypes.filter(entry => entry.ID == id);
                if (filterresult.length == 1) {
                    editDescription.setValue(filterresult[0].description);
                }
            }

        }, this.configurationData.availableCosttypes));
    }

    private _onAddCostRowDlg(input: MdsLax<InstanceType<typeof SelectBox>>, numberInput: MdsLax<InstanceType<typeof NumberInput>>, editDescription: MdsLax<InstanceType<typeof Edit>>) {
        let costtypeID = input.getValue() as string;
        
        let num = numberInput.getValue() as number;

        let description = editDescription.getValue() as string;

        if (!!costtypeID) {
            this._modifyCostRow(costtypeID, num, "add", description);
        }
    }
    private _modifyCostRow(param1: any, param2: any, mode: "add" | "remove", description?: string ) {

        let data: any =
        {
            mode: mode,
            projectID: this._evProjectId
        };

        switch (mode) {

            case "add":

                data.costtypeID = param1;
                data.value = param2;
                data.description = description;
                break;

            case "remove":
                data.costEntityID = param1;
                break;

    }

        console.log("Webtool_API_BudgetCalculation__SaveCostEntry", data);

        this.StandbyStart(this.costCalculationContainer);


        this.RequestManager.callfunction("Webtool_API_BudgetCalculation__SaveCostEntry",
            data,
            lang.hitch(this, this._onModifyCostRowResult, true),
            lang.hitch(this, this._onModifyCostRowResult, false)
        );
    }

    private _onModifyCostRowResult(success: boolean, response) {
        this.StandbyStop();

        if (success) {
            console.log(this.id + " _onModifyCostRowResult");
            if (typeof response == "object") {
                this._setConfigurationData(response);
            }
        } else {
            let error = response as more.requestErrorMessage;
            console.error(this.id + " _onModifyCostRowResult");
            this.showToast({
                title: "error saving cost row",
                message: error.Message,
                iconClass: toasterIcons.error
            });
        }
    }
    private _onValidatePctInput(newValue: number): boolean | string {
        if (typeof newValue == "number") {
            if (newValue > 99) return false;
            if (newValue < 1) return false;

            let valueAsId = newValue.toFixed(0);
            if (this.costCalculationTable.getColumn(valueAsId)) {
                return "BudgetCalculation_Error__UtilizationLvlAlreadyExisting";
            }


            return true;
        }
        return false;
    }
    private _onClick_ModifyPctColumn(column: SpreadsheetTableTypes.Column<BudgetTypes.EvCost>) {
        if (this.costCalculationTable.isDirty()) {
            this.showToast("BudgetCalculation_Message__SavePendingChangesFirst", toasterIcons.info);
            return;
        }
        let previousValue = parseInt(column.columnID);

        let input = new NumberInput();
        input.setLabel("BudgetCalculation_Label__UtilizationLvl");
        input.setPlaces(0);
        input.setRange(0, 99);
        input.setUnit("%");
        input.setValue(previousValue);

        input.setCustomValidation(lang.hitch(this, this._onValidatePctInput));

        let dlg = new GenericDialog();
        dlg.setup({
            content: input,
            header: "BudgetCalculation_Label__ChangeUtilizationLvl",
            callback: lang.hitch(this, this._onModifyPctDlg, input, previousValue),
            buttonPreset: "okcancel",
            distinctiveNoCallback: "silentclose",
            size: "smaller",
            closeOnEnter: true
        });

        input.focus();

        dlg.disableButton("ok");

        input.on("change", lang.hitch(dlg, "enableButton", "ok"));
    }

    private _onModifyPctDlg(input: MdsLax<InstanceType<typeof NumberInput>>, previousValue: number) {
        let value = input.getValue() as number;

        if (typeof value != "number") {
            return;
        }


        this._changeUtilizationLevel(value, "modify", previousValue);
    }
    private _onClick_AddPctColumn() {
        let input = new NumberInput();
        input.setLabel("BudgetCalculation_Label__UtilizationLvl");
        input.setPlaces(0);
        input.setRange(0, 99);
        input.setUnit("%");
        input.setCustomValidation(lang.hitch(this, this._onValidatePctInput));


        let dlg = new GenericDialog();
        dlg.setup({
            content: input,
            header: "BudgetCalculation_Label__AddUtilizationLvl",
            callback: lang.hitch(this, this._onAddPctDlg, input),
            buttonPreset: "okcancel",
            distinctiveNoCallback: "silentclose",
            size: "smaller"
        });

        dlg.disableButton("ok");

        input.on("change", lang.hitch(dlg, "enableButton", "ok"));
    }

    private _onAddPctDlg(input: MdsLax<InstanceType<typeof NumberInput>>) {
        let value = input.getValue() as number;

        if (typeof value != "number") {
            return;
        }


        this._changeUtilizationLevel(value, "add");
    }

    private _changeUtilizationLevel(levelValue: number, mode: "add" | "remove" | "modify" | "fix" | "unfix", previousValue?: number) {

        let data: any =
        {
            projectID: this._evProjectId
        };

        if (mode == "add") {
            data.addUtilization = levelValue;
        }

        if (mode == "remove") {
            data.removeUtilization = levelValue;
        }
        if (mode == "modify") {
            data.modifyUtilization = levelValue;
            data.targetValue = previousValue;
        }
        if (mode == "fix") {
            data.fixUtilization = levelValue;
        }
        if (mode == "unfix") {
            data.unfixUtilization = levelValue;
        }

        console.log("Webtool_API_BudgetCalculation__SaveUtilizationLevels", data);
        //return;

        this.StandbyStart(this.costCalculationContainer);

        this.RequestManager.callfunction("Webtool_API_BudgetCalculation__SaveUtilizationLevels",
            data,
            lang.hitch(this, this._onChangeUtilizationResult, true),
            lang.hitch(this, this._onChangeUtilizationResult, false)
        );
    }

    private _onChangeUtilizationResult(success: boolean, response) {
        this.StandbyStop();

        if (success) {
            console.log(this.id + " _onChangeUtilizationResult");
            if (typeof response == "object") {
                this._setConfigurationData(response);
            }
        } else {
            let error = response as more.requestErrorMessage;
            console.error(this.id + " _onChangeUtilizationResult");
            this.showToast({
                title: "error saving utilization column",
                message: error.Message,
                iconClass: toasterIcons.error
            });
        }
    }

    private emitStatus(): void {
        let hasFixedCol = false;
        let negativeCalc = false;
        if (this.costCalculationTable) {
            try {
                let columns = this.costCalculationTable.getColumns();
                for (let col of columns) {
                    if (this.isUtilizationFixed(col)) {
                        hasFixedCol = true;
                        
                        let summaries = this.costCalculationTable.getSummaryCells(col);
                        if (summaries.length) {
                            if (summaries[0].value < 0) {
                                negativeCalc = true;
                            }
                        }

                        break;
                    }
                }

            } catch (ex) { }
        }

        let statusObj: BudgetTypes.BudgetTableStatus = {
            negativeCalcResult: negativeCalc,
            hasFixedUtilization: hasFixedCol,
            hasContent: !!this.pricesTable || !!this.costCalculationTable,
            dirty: this.costCalculationTable ? this.costCalculationTable.isDirty() : false
        }
        
        this.emit("status", statusObj);
          
        let expander = this._uiFrameExpandableSection;
        if (expander && !expander._destroyed && this.currentDisplayMode == "expander") {
            expander.setMarking(statusObj.hasContent ? statusObj.hasFixedUtilization ? statusObj.negativeCalcResult ? ExpandableSectionMarkings.warning : ExpandableSectionMarkings.checked : ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        }
    }

    private isUtilizationFixed(col: SpreadsheetTableTypes.Column<BudgetTypes.EvCost>): boolean {
        // wir brauchen einfach IRGENDeinen Datensatz der Tabelle, weil jeder dieselben %-Wertspalten haben muss
        let rows = this.costCalculationTable.getRows();
        let ownUtilization = parseInt(col.columnID);
        if (isNaN(ownUtilization)) return false;

        let result = false;
        for (let row of rows) {
            let entity = this.costCalculationTable.getRowDataEntity(row.rowID);
            if (entity) {
                result = false;

                if (typeof entity.utilization_level_ev_finance_cm == "number") {
                    if (ownUtilization == entity.utilization_level_ev_finance_cm) {
                        result = true;
                    }
                    break;
                }
            }
        }

        return result;
    }

    private _onCheck_UnfixUtilizationLevelColumn(col: SpreadsheetTableTypes.Column<BudgetTypes.EvCost>): boolean {
        
        return this.isUtilizationFixed(col) == true;
    }

    private _onCheck_FixUtilizationLevelColumn(col: SpreadsheetTableTypes.Column<BudgetTypes.EvCost>): boolean {
        return this.isUtilizationFixed(col) == false;
    }

    private _onClick_FixUtilizationLevelColumn(col: SpreadsheetTableTypes.Column<BudgetTypes.EvCost>) {
        let ownUtilization = parseInt(col.columnID);
        let mode: "fix" | "unfix" = "fix";
        if (isNaN(ownUtilization)) return;

        if (this.costCalculationTable.isDirty()) {
            this.showToast("BudgetCalculation_Message__SavePendingChangesFirst", toasterIcons.info);
            return;
        }

        if (this._onCheck_FixUtilizationLevelColumn(col) == false) {
            // die Spalte kann nicht fixiert werden. der Klick hier bedeutet also, dass wir vom UNFIX kommen.
            mode = "unfix"
        }

        this._changeUtilizationLevel(ownUtilization, mode);
    }


    private _onSelect_BudgetTemplate(select: MdsLax<InstanceType<typeof SelectBox>>, selectedID: string) {
        if (!selectedID) return;

        let label = select.getValue(true);
        let contentStr = StringHelpers.stringFormat(TranslationHelpers.tryTranslate("BudgetCalculation_Message__ConfirmSelectedBudgetTemplate"), label);


        let dlg = new GenericDialog();
        dlg.setup("smallYesNoQuestion", lang.hitch(this, this._onConfirmSelectedBudgetTemplate, select), contentStr, "BudgetCalculation_Label__CreateBudgetFromTemplate");
        dlg.setup({
            header: "BudgetCalculation_Label__CreateBudgetFromTemplate",
            content: contentStr,
            size: "smaller",
            contentIconClass: toasterIcons.question,
            buttonPreset: "yesno",
            callback: lang.hitch(this, this._onConfirmSelectedBudgetTemplate, select),
            distinctiveNoCallback: "silentclose"
        });
    }

    private _onConfirmSelectedBudgetTemplate(select: MdsLax<InstanceType<typeof SelectBox>>) {
        if (!select) return;
        let selectedID = select.getValue();
        if (!selectedID) return;

              
        let data: any = {
            projectID: this._evProjectId,
            templateID: selectedID
        };

      
        this.StandbyStart(this.costCalculationContainer);


        this.RequestManager.callfunction("Webtool_API_BudgetCalculation__CreateBudgetFromTemplate",
            data,
            lang.hitch(this, this._onCreateBudgetFromTemplateResponse, true, select),
            lang.hitch(this, this._onCreateBudgetFromTemplateResponse, false, select)
        );
    }

    private _onCreateBudgetFromTemplateResponse(success: boolean, select: MdsLax<InstanceType<typeof SelectBox>>, response) {
        this.StandbyStop();

        if( select) select.setValue(null, true);

        if (success) {
            console.log(this.id + " _onCreateBudgetFromTemplateResponse");
            if (typeof response == "object") {
                this._setConfigurationData(response);

                if (select) select.destroy();
            }
        } else {
            let error = response as more.requestErrorMessage;
            console.error(this.id + " _onCreateBudgetFromTemplateResponse");
            this.showToast({
                title: "error creating budget from template",
                message: error.Message,
                iconClass: toasterIcons.error
            });
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(BudgetTable);